module.exports = __webpack_public_path__ + "static/media/pattern-delete-icon.d40a83fb.svg";